import { z } from 'zod'

export const createTestNotificationSchema = z.object({
  delaySeconds: z.coerce.number().int().min(1).max(3600),
})

export type CreateTestNotificationDto = z.infer<typeof createTestNotificationSchema>
